import { render } from "./OpenInActivatorDropdownButton.vue?vue&type=template&id=3b519db2&scoped=true"
import script from "./OpenInActivatorDropdownButton.vue?vue&type=script&lang=js"
export * from "./OpenInActivatorDropdownButton.vue?vue&type=script&lang=js"

import "./OpenInActivatorDropdownButton.vue?vue&type=style&index=0&id=3b519db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b519db2"]])

export default __exports__